import {dataTestId} from '@hconnect/uikit/src/common'
import {HPButton, HPButtonProps} from '@hconnect/uikit/src/lib2'
import {Refresh} from '@mui/icons-material'
import {ButtonProps} from '@mui/material'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useOptimizerSettings} from '../../hooks'
import {useDialog} from '../../providers'

import {RecalculatePlanDialogContent} from './RecalculatePlanDialogContent'

export const StartRecalculationButton = (
  {
    variant,
    backgroundMode
  }: Pick<ButtonProps, 'variant'> & Pick<HPButtonProps, 'backgroundMode'> = {
    variant: 'contained',
    backgroundMode: 'medium'
  }
) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const {openDialog} = useDialog()

  const {data: optimizerSettings} = useOptimizerSettings()

  const handleOpenSettings = useCallback(() => {
    openDialog({
      header: {title: t('optimizer.recalculatePlan')},
      content: <RecalculatePlanDialogContent />,
      dataTestId: 'recalculate_optimizer_dialog'
    })
  }, [openDialog, t])

  return (
    <HPButton
      startIcon={<Refresh />}
      variant={variant}
      backgroundMode={backgroundMode}
      color="secondary"
      disabled={!optimizerSettings}
      onClick={handleOpenSettings}
      {...dataTestId('recalculate_optimized_planning_button')}
    >
      {t('optimizer.recalculateOptimizedPlan')}
    </HPButton>
  )
}
